:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

/*---------------------------
gxg-tree-view
---------------------------*/
gxg-tree-view {
  --gxg-tree-view-icon-size: var(--spacing-comp-03);
  display: contents;
  color: var(--color-on-background);
  font-family: var(--font-family-primary);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
}

/*---------------------------
.tree-view
---------------------------*/
.tree-view {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.tree-view::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.tree-view::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.tree-view::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.tree-view::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}
.tree-view .ch-tree-view-container {
  padding: 7px;
  /*although this value does not exists in gemini ds space tokens, it is the value that works best with gx-ide*/
}

/*---------------------------
.tree-view-item
---------------------------*/
.tree-view-item {
  /*-- Custom vars ---*/
  --ch-tree-view-view__checkbox-size: var(--gxg-checkbox-size);
  --ch-tree-view-view__expandable-button-width: var(--gxg-tree-view-icon-size);
  --ch-tree-view-item-gap: var(--spacing-comp-02);
  --ch-tree-view-item-custom-padding-inline-start: var(--spacing-comp-01);
  --ch-tree-view-item-custom-padding-inline-end: var(--spacing-comp-01);
  /*-- Parts ---*/
  /*-- Parts for checkbox ---*/
  /*checked*/
  /*indeterminate*/
  /*-- Dynamic Icons ---*/
  /*-- Other ---*/
}
.tree-view-item::part(dashed-line) {
  border-color: var(--gray-02);
}
.tree-view-item::part(header) {
  min-height: var(--spacing-comp-05);
  padding-top: var(--spacing-comp-00);
  padding-bottom: var(--spacing-comp-00);
  padding-inline-end: var(--spacing-comp-02);
}
.tree-view-item::part(header):hover {
  background-color: var(--gxg-background-color--hover);
  color: var(--gxg-color--hover);
}
.tree-view-item::part(header):focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
.tree-view-item[selected]::part(header) {
  background-color: var(--gxg-background-color--selected);
}
.tree-view-item[selected]::part(header):hover {
  background-color: var(--gxg-background-color--selected-hover);
}
.tree-view-item::part(expandable-button) {
  background-color: var(--gray-00);
}
.tree-view-item::part(expandable-button)::before {
  background-color: var(--gray-04);
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
}
.tree-view-item::part(expandable-button):hover {
  background-color: var(--color-background);
}
.tree-view-item::part(expandable-button):focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: 0;
}
.tree-view-item::part(left-img) {
  width: var(--spacing-comp-04);
  height: var(--spacing-comp-04);
}
.tree-view-item::part(downloading) {
  width: var(--spacing-comp-03);
  height: var(--spacing-comp-03);
  border: var(--border-width-md) solid var(--color-primary-enabled);
  border-inline-start-color: transparent;
}
.tree-view-item::part(checkbox__container) {
  border-color: var(--gray-04);
  background-color: var(--color-background);
}
.tree-view-item::part(checkbox__container):after {
  content: "";
  position: absolute;
  display: block;
  border: solid;
  border-color: transparent;
  z-index: 0;
}
.tree-view-item::part(checkbox__container):focus-within {
  box-shadow: none;
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
.tree-view-item::part(checkbox__option) {
  display: none;
}
.tree-view-item::part(checkbox__container checkbox__checked):after {
  left: 5.5px;
  top: 3px;
  width: 4px;
  height: 7px;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  border-color: var(--color-primary-active);
  transition-property: border-color;
  transition-duration: var(--ui-animaton-speed);
  transition-timing-function: ease;
}
.tree-view-item::part(checkbox__container checkbox__indeterminate):after {
  left: 50%;
  top: 50%;
  width: 8px;
  height: 1.5px;
  border: 0;
  background-color: var(--color-primary-active);
  -webkit-transform: rotate(0) translateY(-50%) translateX(-50%);
  -ms-transform: rotate(0) translateY(-50%) translateX(-50%);
  transform: rotate(0) translateY(-50%) translateX(-50%);
}
.tree-view-item::part(checkbox__input) {
  position: relative;
  z-index: 1;
}
.tree-view-item--folder::part(action)::before, .tree-view-item--module::part(action)::before {
  grid-area: left-img;
  content: "";
  width: var(--gxg-tree-view-icon-size);
  height: var(--gxg-tree-view-icon-size);
  margin-inline-end: var(--ch-tree-view-item-gap);
  background-repeat: no-repeat;
}
.tree-view-item--folder::part(action)::before {
  background-image: url("/build/icon-assets/objects/folder.svg");
}
.tree-view-item--folder::part(action expanded)::before {
  background-image: url("/build/icon-assets/objects/folder-open.svg");
}
.tree-view-item--module::part(action)::before {
  background-image: url("/build/icon-assets/objects/module.svg");
}
.tree-view-item--module::part(action expanded)::before {
  background-image: url("/build/icon-assets/objects/module-open.svg");
}
.tree-view-item--pending-commit::part(action)::before {
  content: "";
  position: relative;
  z-index: 1;
  grid-area: left-img;
  width: 5px;
  height: 5px;
  align-self: end;
  margin-block-end: 3px;
  margin-inline-start: 1px;
  background-color: var(--color-primary-enabled);
  border-radius: 50%;
}

/*-- Other Selectors (these depend on the tag class name)---*/
.tree-view-item--editing::part(header) {
  border: 2px solid transparent;
}
/*--- Revisar ---*/
.tree-view .ch-tree-view-drag-info {
  padding-inline: 6px;
  padding-block: 2px;
  background-color: #cfdee6;
  border: 1px solid #0266a0;
  border-radius: 10px;
  font-size: 8px;
}